import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function DatenschutzPage() {
  return (
    <div data-testid="datenschutz-page" className="min-h-screen bg-[#0C1620]">
      {/* Header */}
      <header className="bg-[#0C1620]/80 backdrop-blur-xl border-b border-[#3A4F60]/30">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 flex items-center h-16">
          <Link
            to="/"
            data-testid="back-to-home"
            className="flex items-center gap-2 text-[#8899AA] hover:text-[#C5993A] transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            <span className="text-sm">Zurück zur Startseite</span>
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 lg:px-8 py-16 sm:py-24">
        <h1 className="font-heading text-4xl sm:text-5xl text-white font-light mb-12">
          Datenschutzerklärung
        </h1>

        <div className="space-y-8 text-[#F0F4F8] font-light leading-relaxed">
          <section>
            <h2 className="font-heading text-2xl text-[#C5993A] mb-4">
              1. Datenschutz auf einen Blick
            </h2>
            <h3 className="text-lg text-white mb-2 font-medium">Allgemeine Hinweise</h3>
            <p>
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren
              personenbezogenen Daten passiert, wenn Sie diese Website besuchen.
              Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert
              werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie
              unserer unter diesem Text aufgeführten Datenschutzerklärung.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl text-[#C5993A] mb-4">
              2. Verantwortliche Stelle
            </h2>
            <p>Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</p>
            <div className="mt-3 bg-[#12202f] border border-[#3A4F60]/30 rounded-lg p-6">
              <p>VMBS UG</p>
              <p>Hr. Stefan Schäfer</p>
              <p>Ludwigstraße 9</p>
              <p>85298 Scheyern</p>
              <p className="mt-2">
                Telefon:{" "}
                <a href="tel:+498441804144" className="text-[#C5993A]">
                  +49 84 41 80 41 44
                </a>
              </p>
              <p>
                E-Mail:{" "}
                <a href="mailto:info@vmbs.de" className="text-[#C5993A]">
                  info@vmbs.de
                </a>
              </p>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-2xl text-[#C5993A] mb-4">
              3. Datenerfassung auf dieser Website
            </h2>
            <h3 className="text-lg text-white mb-2 font-medium">Cookies</h3>
            <p>
              Diese Website verwendet ausschließlich technisch notwendige Cookies. Technisch
              notwendige Cookies sind für das Funktionieren der Website erforderlich und
              können in unseren Systemen nicht abgeschaltet werden. Sie werden in der Regel
              nur als Reaktion auf von Ihnen getätigte Aktionen gesetzt, die einer
              Dienstanforderung entsprechen, wie etwa das Festlegen Ihrer
              Datenschutzeinstellungen oder das Ausfüllen von Formularen.
            </p>

            <h3 className="text-lg text-white mb-2 mt-6 font-medium">Kontaktformular</h3>
            <p>
              Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre
              Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen
              Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von
              Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre
              Einwilligung weiter.
            </p>
            <p className="mt-3">
              Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b
              DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder
              zur Durchführung vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen
              Fällen beruht die Verarbeitung auf unserem berechtigten Interesse an der
              effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f
              DSGVO) oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl text-[#C5993A] mb-4">
              4. Ihre Rechte
            </h2>
            <p>Sie haben jederzeit das Recht:</p>
            <ul className="list-disc list-inside mt-3 space-y-2 text-[#8899AA]">
              <li>unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten (Art. 15 DSGVO)</li>
              <li>die Berichtigung unrichtiger Daten zu verlangen (Art. 16 DSGVO)</li>
              <li>die Löschung Ihrer bei uns gespeicherten Daten zu verlangen (Art. 17 DSGVO)</li>
              <li>die Einschränkung der Verarbeitung zu verlangen (Art. 18 DSGVO)</li>
              <li>Widerspruch gegen die Verarbeitung einzulegen (Art. 21 DSGVO)</li>
              <li>die Datenübertragbarkeit zu verlangen (Art. 20 DSGVO)</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-2xl text-[#C5993A] mb-4">
              5. Hosting
            </h2>
            <p>
              Diese Website wird extern gehostet. Die personenbezogenen Daten, die auf
              dieser Website erfasst werden, werden auf den Servern des Hosters gespeichert.
              Hierbei kann es sich v. a. um IP-Adressen, Kontaktanfragen, Meta- und
              Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen, Websitezugriffe und
              sonstige Daten, die über eine Website generiert werden, handeln.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl text-[#C5993A] mb-4">
              6. SSL-/TLS-Verschlüsselung
            </h2>
            <p>
              Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung
              vertraulicher Inhalte, wie zum Beispiel Anfragen, die Sie an uns als
              Seitenbetreiber senden, eine SSL- bzw. TLS-Verschlüsselung. Eine
              verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des
              Browsers von „http://" auf „https://" wechselt und an dem Schloss-Symbol in
              Ihrer Browserzeile.
            </p>
          </section>
        </div>
      </main>

      <footer className="border-t border-[#3A4F60]/30 py-6">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
          <p className="text-[#3A4F60] text-xs">
            &copy; {new Date().getFullYear()} VMBS UG
          </p>
        </div>
      </footer>
    </div>
  );
}
